export default __webpack_public_path__ + "static/media/6.67a6d87a.jpg";